










































import { Component, Vue } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import DataTable from '@/trials/views/components/DataTable.vue';
import TrainParams from '@/trials/domain/objects/trainParams';

@Component({ components: { DataTable } })
export default class TrainResultParams extends Vue {
    /*----------------------------------*
     * Props
     *-----------------------------------*/
    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private scoresDataSet: any[] = [];
    private headers: any[] = [];
    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    created() {
        this.makeDataSet();
    }
    /*----------------------------------*
     * Methods
     *-----------------------------------*/
    private makeDataSet() {
        const trainParams: TrainParams | null = sessionModule.getTrainParams;

        if (trainParams == null) {
            return;
        }

        // scores
        Object.keys(trainParams.bestScores).forEach(key => {
            const row = { key: key, value: trainParams.bestScores[key] };
            this.scoresDataSet.push(row);
        });
    }

    private formatScore(value: any) {
        if (typeof value !== 'number' || isNaN(value) || !isFinite(value)) {
            return value;
        }

        return value.toFixed(3);
    }
}
